module.exports = __webpack_public_path__ + "media/images/vp/icon.info.black-bd961245c89f9639b1eebcf31e1fd50e.svg";